import type { ItemType } from "./atoms";

const liveItemPrefix = "live-content-item";
const timelineItemPrefix = "timeline-item";

export const getContainerId = (type: ItemType): string => {
  switch (type) {
    case "content":
      return "content-container";
    case "timeline":
      return "timeline-container";
  }

  return "";
};

export const getItemContainerId = (type: ItemType, entityId: string): string => {
  switch (type) {
    case "content":
      return `${liveItemPrefix}-${entityId ?? ""}`;
    case "timeline":
      return `${timelineItemPrefix}-${entityId ?? ""}`;
  }
  return "";
};

export const checkIfElementIsLiveItem = (elementId: string): boolean =>
  elementId.startsWith(liveItemPrefix);
